/**
 * ConnectionPill — leading filled-dot status pill for the Xero header. Colour
 * AND label carry the meaning (DESIGN.md §16 colour-as-only-information ban);
 * the dot is a filled circle, never an emoji (reference plan requirement).
 */
import { cn } from '@/lib/utils';
import type { ConnectionPill as PillState } from '../lib/connection';

const PILL_CONFIG: Record<
  PillState,
  { label: string; dot: string; text: string }
> = {
  connected: { label: 'Connected', dot: 'bg-emerald-500', text: 'text-emerald-700' },
  expiring: { label: 'Token expiring soon', dot: 'bg-amber-500', text: 'text-amber-700' },
  not_connected: { label: 'Not connected', dot: 'bg-slate-400', text: 'text-muted-foreground' },
  broken: { label: 'Reconnect needed', dot: 'bg-red-500', text: 'text-red-700' },
};

export function ConnectionPill({ state }: { state: PillState }) {
  const config = PILL_CONFIG[state];
  return (
    <span
      role="status"
      className={cn(
        'inline-flex items-center gap-1.5 text-xs font-medium',
        config.text
      )}
    >
      <span className={cn('h-1.5 w-1.5 rounded-full', config.dot)} aria-hidden="true" />
      {config.label}
    </span>
  );
}
